import dynamic from "next/dynamic";
import React from "react";

// @ts-ignore
const LocationPicker: typeof import("./LocationPickerRaw").default = dynamic(() => import("./LocationPickerRaw"), {
  ssr: false
});
export default LocationPicker;